import { Location } from '@angular/common';
import { Component, ElementRef, Injectable, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSidenav } from '@angular/material/sidenav';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterOutlet } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { MessageUtilities } from '../../../class/message-utilities';
import { UnsubscribeAll } from '../../../class/unsubscribe-all';
import { Utilities } from '../../../class/utilities';
import { Message } from '../../../interface/message';
import { SideMenu, SideMenuChild } from '../../../interface/side-menu';
import { CompanyService } from '../../../service/company.service';
import { DataCacheService } from '../../../service/data-cache.service';
import { DataService } from '../../../service/data.service';
import { LayoutService } from '../../../service/layout.service';
import { MessageService } from '../../../service/message.service';
import { ReverseRouterService } from '../../../service/reverse-router.service';
import { RoService } from '../../../service/ro.service';
import { SnackbarService } from '../../../service/snackbar.service';
import { authorizationTypes } from '../../../shared/lists/authorization-types';
import { companyStates } from '../../../shared/lists/company-states';
import { messageTypes } from '../../../shared/lists/message-types';
import { RO_STATES } from '../../../shared/lists/ro-states';
import { roles } from '../../../shared/lists/roles';
import { Company, COMPANY_STATE } from '../../../interface/company';
import { filter, first } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { fade4, fadeAnimation, fadeSlide, routerTransition, triggerAnimation } from './animations';
import { MatDialog } from '@angular/material/dialog';
import { T5MsgDialogComponent } from './t5-msg-dialog/t5-msg-dialog.component';
import { T5MessagesService } from 'src/app/service/t5-messages.service';
import laborIcon from '../../../../assets/images/icons/labor';
import whatsAppIcon from '../../../../assets/images/icons/whatsapp';
import { FormControl } from '@angular/forms';
import { CachedOsService } from '../../page/company/os/services/cached-os.service';
import { BOOLEAN_TWO } from '@app/shared/common-enums/boolean-two';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [fade4, fadeAnimation, routerTransition, triggerAnimation, fadeSlide]
})
@Injectable()
export class HeaderComponent extends UnsubscribeAll implements OnInit, OnDestroy {

  @ViewChild('rightDrawer', { static: false }) rightDrawer: MatSidenav;

  Utilities = Utilities;
  COMPANY_STATES = COMPANY_STATE;
  BOOLEAN_TWO = BOOLEAN_TWO
  roles = roles;

  messages: Message[];
  unread = 0;
  newUsers = 0;

  isPO360 = environment.dota;
  APP_NAME = environment.envName;

  T5Msgs = [];

  T5MsgMenuVisible = false;

  constructor(
    public companyService: CompanyService,
    public dataService: DataService,
    public layout: LayoutService,
    private reverseRouter: ReverseRouterService,
    private location: Location,
    private messageService: MessageService,
    private roService: RoService,
    private auth: AngularFireAuth,
    private router: Router,
    private snackbar: SnackbarService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private _dataCacheService: DataCacheService,
    private dialog: MatDialog,
    private t5Messages: T5MessagesService,
    private _commonOsService: CachedOsService
  ) {
    super();
    this.iconRegistry.addSvgIconLiteral('labor', this.sanitizer.bypassSecurityTrustHtml(laborIcon));
    this.iconRegistry.addSvgIconLiteral('whatsapp', this.sanitizer.bypassSecurityTrustHtml(whatsAppIcon));
  }

  ngOnInit() {
    this.getData();
  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  ativaSnack() {
    this.newMessageSnackbar();
  }

  private getData() {
    this.newUsers = this.layout.menu.newUsers;
    this.messageService.getAll().subscribe(messagesMap => {
      try {
        if (this.messages && this.messages.length < messagesMap.size) {
          this.newMessageSnackbar()
        }
      } catch (error) {
        console.error(error)
      }

      this.messages = [];

      this.dataService.company$.pipe(
        filter(c => !!c),
        first()
      ).subscribe(company => {
        const readMessages = MessageUtilities.getReadMessages(company.id);
        this.unread = 0;
        if (!messagesMap) { return }
        messagesMap.forEach(message => {

          if (message.type >= messageTypes.authorized.id && message.type <= messageTypes.evaluated.id) {
            for (let readMessage of readMessages) {
              if (readMessage == message.id) {
                message.read = true;
                break;
              }
            }
            if (!message.read) {
              this.unread++;
            }
            this.messages.push(message);
          }
        });
        this.messages = this.messages.sort((a, b) => {
          if (a.read !== b.read) {
            return a.read ? 1 : -1;
          }
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();

        });
      })
    });

    this.dataService.user$
      .pipe(filter(user => !!user))
      .subscribe((user) => {
        this.companyService.getAll().then(companies => user?.defineCompanies(companies))
      });

    this.t5Messages.getAll().then(messages => {
      this.T5Msgs = messages;
    });

    if (this.layout.component == '') {
      this.newUsers = 0
      return
    }
    setTimeout(() => {
      if (this.layout.menu.newUsers > this.newUsers) {
        this.newUsers = this.layout.menu.newUsers;
        this.newRequestSnackbar()
      }
    }, 1600);
  }

  async toggleMessages() {
    this.rightDrawer.toggle();
    if (this.rightDrawer.opened && this.messages && this.messages.length && !this.messages[0].ro) {
      this.layout.loader = true;
      const actives = await this.roService.getAll(RO_STATES.all);
      const finisheds = await this.roService.getAll(RO_STATES.finished);
      const roList = new Map(Array.from(actives).concat(Array.from(finisheds)));

      this.messages.forEach(message => {
        message.ro = roList.get(message.text);
      });
      let messagesFiltered = [];

      for (const message of this.messages) {
        if (message.ro) {
          messagesFiltered.push(message);
        }
      }
      this.messages = messagesFiltered;
      this.layout.loader = false;
    }
  }

  newMessageSnackbar() {
    try {
      this.snackbar.info('NEW');
    } catch (error) {
      this.layout.loader = false;
    }
  }

  newRequestSnackbar() {
    const user = this.layout.newUserName;
    try {
      this.snackbar.info('NEW_USER', { user: user });
    } catch (error) {
      this.layout.loader = false;
    }
  }

  goBack() {
    if (this.layout.component === 'blocked') {
      this.router.navigate(['/company'])
      return
    }
    if (window.history.length > 1) {
      this.location.back()
    } else {
      this.router.navigate(['/company'])
    }
  }

  async signOut() {
    this.auth.signOut();
  }

  public resetCache(component: string) {
    this.reverseRouter.clear();
    this._dataCacheService.reset();

    console.log({component})
    if (!["budgets", "opened", "rejected", "budget", "closed-budget", "ended", "ro", "closed"].includes(component)) {
      this._commonOsService.clearCache();
    }
  }

  public navigateOrExpand(menu: SideMenu | SideMenuChild) {
    if (!menu.href || this.layout.component === menu.component || menu.component === 'budgets') {
      this.layout.toggle(menu.component, menu["isTopLevel"]);
      return
    }
    this.router.navigate(menu.href, {
      queryParams: menu.queryParams
    });
  }

  changeCompany(company: Company){
    let currentUrl = this.router.url.split('/').slice(1);

    this.dataService.company$.pipe(first()).subscribe(currComp => {
      if(company && currComp){
        const idIndex = currentUrl.findIndex(id => id === currComp.id);
        if (idIndex !== -1) {
          currentUrl[idIndex] = company.id;

          if (currentUrl.find(urlPart => urlPart === "detail")) {
            currentUrl = currentUrl.splice(0, currentUrl.length - 2);
            currentUrl.push("budget");
          } else if (company.currentState === COMPANY_STATE.integrated) {
            currentUrl = ["company", company.id, "os","budget"]
          };

          const newUrl = '/' + currentUrl.join('/');
          window.location.href = newUrl;
          return;
        }
      }
      this.router.navigate(['company', company.id]);
    })

  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  toggleT5MsgDropdown() {
    this.T5MsgMenuVisible = !this.T5MsgMenuVisible;
  }

  openT5MsgDialog(item: any): void {
    this.dialog.open(T5MsgDialogComponent, {
      data: {
        title: item.title,
        description: item.description,
        postedTime: item.postedTime,
        link: item.link,
        image: item.image
      },
      panelClass: 't5-msg-dialog-container'
    });

    if (item._id) {
      this.t5Messages.markAsRead(item._id)
        .then(() => {
          const index = this.T5Msgs.findIndex(msg => msg._id === item._id);
          if (index !== -1) {
            this.T5Msgs[index].messageStatus = 2;
          }
        })
        .catch(error => console.error('Error marking message as read:', error));
    }

    this.T5MsgMenuVisible = false;
  }

}
